var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretDownGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9827 0.27124H9.97827C9.90996 0.27124 9.84568 0.304722 9.8055 0.359633L6.00059 5.60428L2.19568 0.359633C2.1555 0.304722 2.09121 0.27124 2.02291 0.27124H1.01845C0.931392 0.27124 0.880499 0.370348 0.931392 0.44133L5.65371 6.9516C5.82514 7.18731 6.17603 7.18731 6.34612 6.9516L11.0684 0.44133C11.1207 0.370348 11.0698 0.27124 10.9827 0.27124Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownGray);
export default __webpack_public_path__ + "static/media/CaretDownGray.dfb3262c5ccd7ad2b6bd90d8538363db.svg";
export { ForwardRef as ReactComponent };